import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { AppInfo } from '../../models/appinfo';
import { ForuscareService } from '../foruscare/foruscare.service';
import { UserService } from '../user/user.service';
import { Title } from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private userId;

  public appMenuFolded;
  public appMenuFoldSource;

  public screenInfoSource = new BehaviorSubject(null);
  public screenInfoMessage;

  public userInfoSource = new BehaviorSubject(null);
  public userInfoMessage;

  public isPasswordResetRequired:Boolean = false;

  public tokenIfCalledFromOtherApp:String = null;
  public decrypted_accessToken:string = null;
  public decrypted_appInfo:AppInfo = null;
  public decrypted_userInfo:any = null;

  constructor(public cookieService: CookieService,
              private foruscareService:ForuscareService,
              private router:Router,
              private userService:UserService,
              private apptitle:Title) { }

  updateRouteInformation(screenInfo: object) {
    this.screenInfoMessage = this.screenInfoSource.asObservable();
    this.screenInfoSource.next(screenInfo)
  }

  updateTheme() {
    if (this.getAppInfo() != null) {
      this.appMenuFoldSource = new BehaviorSubject(this.getAppInfo().menuFolded);
      this.appMenuFolded = this.appMenuFoldSource.asObservable();
    }
  }

  getAppInfo(): AppInfo {
    const email = this.getUserEmail()!;
    if(this.decrypted_appInfo!=null && this.decrypted_appInfo.menuFolded !=null){
      return this.decrypted_appInfo;
    }
    else{
      // let appinfo = this.cookieService.get('appinfo');
      let appinfo = window.localStorage.getItem("user_email");
      if(appinfo!=null && appinfo.length>0){
        appinfo = this.decrypt(appinfo, email);
      }
      if (appinfo == null || appinfo == ""){ 
        return null; 
      }
      this.decrypted_appInfo = JSON.parse(appinfo);
      return this.decrypted_appInfo ;
    }
  }

  getUserInfo(): any {
    const email = this.getUserEmail()!;
    if(this.decrypted_userInfo != null && this.decrypted_userInfo.email!=null){
        return this.decrypted_userInfo ;
    }
    else{
      // let userinfo = this.cookieService.get('userinfo');
      let userinfo = window.localStorage.getItem("userinfo");
      if(userinfo!=null && userinfo.length>0){
        userinfo = this.decrypt(userinfo, email);
      }
      if (userinfo == null || userinfo == ""){
        return null;
      }
      this.decrypted_userInfo = JSON.parse(userinfo);
      return this.decrypted_userInfo;
    }
  }

  setLoggedInUserId(userId) : void {
    this.userId = userId;
  }

  getLoggedInUserId() : string {
    return this.userId;
  }

  setMenuFolded(isMenuFolded: boolean) {
    if (this.appMenuFoldSource != null) {
      this.appMenuFolded.source.next(isMenuFolded);
      var appInfo: any = this.getAppInfo();
      if (appInfo == null) {
        appInfo = AppInfo;
      }
      appInfo.menuFolded = isMenuFolded;
      this.updateAppInfo(appInfo);
    }
    else
      if (this.appMenuFoldSource != null && this.getAppInfo() != null)
        this.appMenuFoldSource.next(this.getAppInfo().menuFolded);
  }

  addUpdateAccessToken(token: string): void {
    const email = this.getUserEmail()!;
    // this.cookieService.set('access_token', this.encrypt(token, email), { secure: true });
    window.localStorage.setItem("access_token", this.encrypt(token, email));
  }
  getAccessToken(): string | null {
    const email = this.getUserEmail();
    // const encryptedToken = this.cookieService.get('access_token');
    var encryptedToken = window.localStorage.getItem("access_token");
    return (email && encryptedToken) ? this.decrypt(encryptedToken, email) : null;
  }

  updateUserInfoSource() {
    if (this.getUserInfo() != null) {
      this.userInfoSource = new BehaviorSubject(this.getUserInfo());
      this.userInfoMessage = this.userInfoSource.asObservable();
    }
  }

  updateUserInfo(userinfo: any) {
    if (userinfo != null && userinfo.value != null) {
      this.addUpdateAccessToken(userinfo.value);
    }
    if (this.userInfoSource != null) {
      if (userinfo.additionalInformation != null) {
        let userInfo = JSON.stringify({ userId:userinfo.additionalInformation.userId,email:userinfo.additionalInformation.userName, userName: userinfo.additionalInformation.name, userRole: userinfo.additionalInformation.roles[0].authority });
        // this.cookieService.set('userinfo', this.encrypt(userInfo, userinfo.additionalInformation.userName),{secure:true});
        window.localStorage.setItem('userinfo', this.encrypt(userInfo, userinfo.additionalInformation.userName));
      }
      this.updateUserInfoSource();
      this.userInfoMessage.source.next(userinfo);
    }
    else
      if (this.userInfoSource != null && this.getUserInfo() != null)
        this.userInfoSource.next(this.getUserInfo().userInfoSource);
  }

  setUserEmail(email: string): void {
    const base64Email = btoa(email);
    // this.cookieService.set("user_email", base64Email);
    window.localStorage.setItem("user_email", base64Email);
  }
  getUserEmail(): string | null {
    // const base64Email = this.cookieService.get("user_email");
    const base64Email = window.localStorage.getItem("user_email");
    return base64Email ? atob(base64Email) : null;
  }

  removeAccessToken(): void {
    this.cookieService.deleteAll();
    window.localStorage.clear();
  }

  updateAppInfo(appinfo: AppInfo): void {
    const email = this.getUserEmail()!;
    // this.cookieService.delete('appinfo');
    //  this.setMenuFolded(appinfo.menuFolded);
    // this.cookieService.set('appinfo', this.encrypt(JSON.stringify(appinfo), email),{secure:true});
    window.localStorage.setItem('appinfo', this.encrypt(JSON.stringify(appinfo), email));
  }

  setIsPasswordResetRequired(value){
    this.isPasswordResetRequired = value;
  }
  getIsPasswordResetRequired(){
    return this.isPasswordResetRequired;
  }

  logout() {
    this.userService.logoutUser(this.getUserInfo().email)
    .subscribe(response=>{
      if(response || response.errorCode==200 || response.errorCode==401 || response.httpErrorCode==401){
        this.decrypted_accessToken = null;
        this.decrypted_appInfo = null;
        this.decrypted_userInfo = null;
        this.apptitle.setTitle("Forus Account Management");
        this.removeAccessToken();
        this.router.navigate(['/login']);
        this.foruscareService.showNotification("Logged  out successfully", "success");
      }
    });
  }

  encrypt(data: any, key: string): string {
    return CryptoJS.AES.encrypt(data, key).toString();
  }

  decrypt(data: string, key: string): string {
    return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
  }
}
